import React from "react";
import { View, StyleSheet } from "react-native";
import { TrendDown, TrendUp } from "@phosphor-icons/react";
import CustomText from "../../../common/general/CustomText/CustomText";
import { colors, radii, spacing, shadowStyles } from "../../../../styles/design-system";
import CustomSpacing from "../../../common/layout/CustomSpacing/CustomSpacing";

export interface MetricCardProps {
  icon: React.ReactNode;
  value: string;
  subValue?: string;
  label: string;
  context: string;
  trend?: "up" | "down" | "neutral";
  trendColor?: string;
  contextColor?: string;
}

const MetricCard: React.FC<MetricCardProps> = ({
  icon,
  value,
  subValue,
  label,
  context,
  trend,
  trendColor = colors.grey[500],
  contextColor = colors.grey[500],
}) => {
  return (
    <View style={[styles.card, shadowStyles.sm]}>
      <View style={styles.cardHeader}>
        <View style={styles.iconContainer}>{icon}</View>
        {trend === "down" && <TrendDown size={16} color={trendColor} weight="bold" />}
        {trend === "up" && <TrendUp size={16} color={trendColor} weight="bold" />}
      </View>

      <View style={styles.valueRow}>
        <CustomText text={value} size="xxl" weight="bold" useTranslationText={false} style={styles.valueText} />
        {subValue && <CustomText text={subValue} size="s" useTranslationText={false} style={styles.subValueText} />}
      </View>

      <CustomText text={label} size="s" useTranslationText={false} style={styles.labelText} />

      <CustomSpacing type="vertical" size="xs" />

      <CustomText text={context} size="xs" useTranslationText={false} style={{ color: contextColor }} />
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    backgroundColor: colors.white,
    borderRadius: radii.xl,
    padding: spacing.lg,
    width: 200,
    borderWidth: 1,
    borderColor: colors.grey[200],
  },
  cardHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: spacing.md,
  },
  iconContainer: {
    backgroundColor: "#F1F5F9",
    padding: 8,
    borderRadius: 12,
    alignItems: "center",
    justifyContent: "center",
  },
  valueRow: {
    flexDirection: "row",
    alignItems: "baseline",
    gap: 4,
    marginBottom: 4,
  },
  valueText: {
    color: colors.grey[900],
  },
  subValueText: {
    color: colors.grey[500],
  },
  labelText: {
    color: colors.grey[600],
  },
});

export default MetricCard;
